import { getAccountSnapshot } from "@/stores/account.store";
import { isPaginated } from "@/types/api/pagination.type";

enum HTTPMethod {
  POST = "POST",
  GET = "GET",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
  OPTIONS = "OPTIONS"
}

const privateFetch = async <ResponseType, BodyType>(
  method: HTTPMethod,
  path: string,
  body?: BodyType
): Promise<ResponseType> => {
  const accountSnapshot = getAccountSnapshot();
  try {
    const response = await fetch(path, {
      method: method,
      headers: [
        ["Content-Type", "application/json"],
        ["Authorization", accountSnapshot.accessToken]
      ],
      body: body ? JSON.stringify(body) : undefined
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message);
    }

    return (!isPaginated(result) ? result.data : result) as ResponseType;
  } catch (err) {
    console.log("Err: " + err);
    throw err;
  }
};

export const get = async <ResponseType>(
  path: string
): Promise<ResponseType> => {
  return privateFetch(HTTPMethod.GET, path);
};

export const post = async <ResponseType, BodyType>(
  path: string,
  body: BodyType
): Promise<ResponseType> => {
  return privateFetch(HTTPMethod.POST, path, body);
};

export const patch = async <ResponseType, BodyType>(
  path: string,
  body: BodyType
): Promise<ResponseType> => {
  return privateFetch(HTTPMethod.PATCH, path, body);
};

export const put = async <ResponseType, BodyType>(
  path: string,
  body: BodyType
): Promise<ResponseType> => {
  return privateFetch(HTTPMethod.PUT, path, body);
};

export const deleteRequest = async <ResponseType>(
  path: string
): Promise<ResponseType> => {
  return privateFetch(HTTPMethod.DELETE, path);
};
